__turbopack_context__.v({
  "categories": "navbar-module__tFXHna__categories",
  "categoriesWrapper": "navbar-module__tFXHna__categoriesWrapper",
  "category": "navbar-module__tFXHna__category",
  "categoryActive": "navbar-module__tFXHna__categoryActive",
  "header": "navbar-module__tFXHna__header",
  "loadingMobileCategories": "navbar-module__tFXHna__loadingMobileCategories",
  "navbar": "navbar-module__tFXHna__navbar",
  "productsContainer": "navbar-module__tFXHna__productsContainer",
  "subcategories": "navbar-module__tFXHna__subcategories",
  "userIcon": "navbar-module__tFXHna__userIcon",
});
